import React, { useState } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    descricaoMenu,
} from '../../../business-components/String/String'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    CardGridEntradaDados,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    GridContainer,
    GridItem6,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TabsPadrao,
    TabPadrao,
} from '../../../business-components/Tab/Tab'

import {
    calculaIdadesDataSimulacao,
} from '../cliente-form/ClienteService'

import tabEstudoFormRevisaoDadosList from '../../../business-rules/List/tabEstudoFormRevisaoDadosList'

import AcompanhamentoFormSeguroVida from '../acompanhamento-form/AcompanhamentoFormSeguroVida'

import CadastroFormObjetivos from '../cadastro-form/CadastroFormObjetivos'

import FormFormReceitaMensal from '../form-form/FormFormReceitaMensal'

import FormFormDiaDia from '../form-form/FormFormDiaDia'

import FormFormEducacao from '../form-form/FormFormEducacao'

import FormFormFinanciamento from '../form-form/FormFormFinanciamento'

import FormFormProjetoVidaSonho from '../form-form/FormFormProjetoVidaSonho'

import FormFormPatrimonioImobilizado from '../form-form/FormFormPatrimonioImobilizado'

import FormFormRecursosFinanceiros from '../form-form/FormFormRecursosFinanceiros'

import EstudoFormPlanejamentoEspecializacaoPeriodoSabatico from './EstudoFormPlanejamentoEspecializacaoPeriodoSabatico'



const EstudoFormRevisaoDados = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, handleSubmitAutomatico,
    vars, /*linhaTipoLicenca, jsonConfiguracao, jsonUsuario, jsonUsuarioAdmin,*/ somenteDespesas, popup}) => {

    const tabEstudoFormRevisaoDadosListAux = tabEstudoFormRevisaoDadosList(vars.linhaTipoLicenca, somenteDespesas)

    const [tabIndexEstudoRevisaoDados, setTabIndexEstudoRevisaoDados] = useState(
        tabEstudoFormRevisaoDadosListAux.length - 1 < values.tabIndexEstudoRevisaoDados
            ?
                0
            :
                values.tabEstudoFormList === LABEL.resumo
                        ?
                            0
                        :
                            values.modoApresentacao &&
                            values.tabEstudoFormList === LABEL.acumulacao &&
                            values.modoApresentacaoAcumulacao === HARDCODE.analisePatrimonialChart &&
                            values.tabIndexEstudoRevisaoDados !== 1 &&
                            values.tabIndexEstudoRevisaoDados !== 2 &&
                            values.tabIndexEstudoRevisaoDados !== 3
                                ?
                                    1
                                :
                                    values.modoApresentacao &&
                                    values.tabEstudoFormList === LABEL.acumulacao &&
                                    values.modoApresentacaoAcumulacao === HARDCODE.receitaAnualChart &&
                                    values.tabIndexEstudoRevisaoDados !== 4
                                        ?
                                            4
                                        :
                                            values.modoApresentacao &&
                                            values.tabEstudoFormList === LABEL.acumulacao &&
                                            values.modoApresentacaoAcumulacao === HARDCODE.despesaAnualChart &&
                                            values.tabIndexEstudoRevisaoDados !== 3 &&
                                            values.tabIndexEstudoRevisaoDados !== 5 &&
                                            values.tabIndexEstudoRevisaoDados !== 6
                                                ?
                                                    5
                                                :
                                                    (
                                                        values.tabEstudoFormList === LABEL.acumulacao ||
                                                        values.tabEstudoFormList === LABEL.protecao ||
                                                        values.tabEstudoFormList === LABEL.gestaoPatrimonial ||
                                                        values.tabEstudoFormList === LABEL.previdenciaPrivada ||
                                                        values.tabEstudoFormList === LABEL.comparacaoCenarios ||
                                                        values.tabEstudoFormList === LABEL.comparacaoEstudos
                                                    ) && 
                                                    values.tabIndexEstudoRevisaoDados === 0
                                                        ?
                                                            1
                                                        :
                                                            values.tabEstudoFormList === LABEL.comparacaoFinanciamentos
                                                                ?
                                                                    3
                                                                :
                                                                    values.tabIndexEstudoRevisaoDados
    )

    const handleTabChangeEstudoRevisaoDados = (e, value) => {
        values.tabIndexEstudoRevisaoDados = value

        setTabIndexEstudoRevisaoDados(value)

        handleSubmitAutomatico(values)
    }

    useSingleton(async () => {

        calculaIdadesDataSimulacao(values, false)

    })

    const GridItemRevisaoDados12PlanejarEspecializacaoPeriodoSabatico6 =
        descricaoMenu(tabEstudoFormRevisaoDadosListAux[tabIndexEstudoRevisaoDados]) ===
            LABEL.planejamentoEspecializacaoPeriodoSabatico ? GridItem6 : GridItem12



    return (
        <div
            className={popup ? 'ml-4 mr-4' : ''}
        >
            <DivForm>
                <TabsPadrao
                    value={tabIndexEstudoRevisaoDados}
                    onChange={handleTabChangeEstudoRevisaoDados}
                    level={3}
                >
                    {tabEstudoFormRevisaoDadosListAux?.map((item, ind) => (
                        <TabPadrao
                            value={ind}
                            label={item}
                            key={ind}
                            level={3}
                        />
                    ))}
                </TabsPadrao>
                <ValidatorFormPadrao
                    onSubmit={handleSubmit}
                    onError={
                        () => null
                    }
                >
                    <GridContainer
                        className="justify-center"
                    >
                        <GridItemRevisaoDados12PlanejarEspecializacaoPeriodoSabatico6>

                        {descricaoMenu(tabEstudoFormRevisaoDadosListAux[tabIndexEstudoRevisaoDados])
                            !== LABEL.planejamentoEspecializacaoPeriodoSabatico && (
                                <CardGridEntradaDados>
                                    <CardGridDivBodyEntradaDados>
                                        <GridContainer
                                            className='mt-2'
                                        >
                                            <GridItem12>
                                                {descricaoMenu(tabEstudoFormRevisaoDadosListAux[tabIndexEstudoRevisaoDados]) ===
                                                    LABEL.objetivos && (
                                                        <CadastroFormObjetivos
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            handleChange={handleChange}
                                                            handleSubmit={handleSubmit}
                                                            setFieldValue={setFieldValue}
                                                            vars={vars}
                                                        />
                                                )}
                                                {descricaoMenu(tabEstudoFormRevisaoDadosListAux[tabIndexEstudoRevisaoDados]) ===
                                                    LABEL.receitaMensal && (
                                                        <FormFormReceitaMensal
                                                            values={values}
                                                            handleChange={handleChange}
                                                            setFieldValue={setFieldValue}
                                                            title={tabEstudoFormRevisaoDadosList(vars.linhaTipoLicenca,
                                                                somenteDespesas)[tabIndexEstudoRevisaoDados]
                                                            }
                                                        />
                                                )}
                                                {descricaoMenu(tabEstudoFormRevisaoDadosListAux[tabIndexEstudoRevisaoDados]) ===
                                                    LABEL.diaDia && (
                                                        <FormFormDiaDia
                                                            values={values}
                                                            handleChange={handleChange}
                                                            setFieldValue={setFieldValue}
                                                            linhaTipoLicenca={vars.linhaTipoLicenca}
                                                            jsonConfiguracao={vars.jsonConfiguracao}
                                                            title={tabEstudoFormRevisaoDadosList(vars.linhaTipoLicenca,
                                                                somenteDespesas)[tabIndexEstudoRevisaoDados]
                                                            }
                                                        />
                                                )}
                                                {descricaoMenu(tabEstudoFormRevisaoDadosListAux[tabIndexEstudoRevisaoDados]) ===
                                                    LABEL.educacao && (
                                                        <FormFormEducacao
                                                            values={values}
                                                            handleChange={handleChange}
                                                            setFieldValue={setFieldValue}
                                                            jsonConfiguracao={vars.jsonConfiguracao}
                                                            title={tabEstudoFormRevisaoDadosList(vars.linhaTipoLicenca,
                                                                somenteDespesas)[tabIndexEstudoRevisaoDados]
                                                            }
                                                        />
                                                )}
                                                {descricaoMenu(tabEstudoFormRevisaoDadosListAux[tabIndexEstudoRevisaoDados]) ===
                                                    LABEL.financiamento && (
                                                        <FormFormFinanciamento
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            handleChange={handleChange}
                                                            handleSubmit={handleSubmit}
                                                            setFieldValue={setFieldValue}
                                                            linhaTipoLicenca={vars.linhaTipoLicenca}
                                                            title={tabEstudoFormRevisaoDadosList(vars.linhaTipoLicenca,
                                                                somenteDespesas)[tabIndexEstudoRevisaoDados]
                                                            }
                                                        />
                                                )}
                                                {descricaoMenu(tabEstudoFormRevisaoDadosListAux[tabIndexEstudoRevisaoDados]) ===
                                                    LABEL.projetoVidaSonho && (
                                                        <FormFormProjetoVidaSonho
                                                            values={values}
                                                            handleChange={handleChange}
                                                            setFieldValue={setFieldValue}
                                                            linhaTipoLicenca={vars.linhaTipoLicenca}
                                                            title={tabEstudoFormRevisaoDadosList(vars.linhaTipoLicenca,
                                                                somenteDespesas)[tabIndexEstudoRevisaoDados]
                                                            }
                                                        />
                                                )}
                                                {descricaoMenu(tabEstudoFormRevisaoDadosListAux[tabIndexEstudoRevisaoDados]) ===
                                                    LABEL.patrimonioImobilizado && (
                                                        <FormFormPatrimonioImobilizado
                                                            values={values}
                                                            handleChange={handleChange}
                                                            setFieldValue={setFieldValue}
                                                            title={tabEstudoFormRevisaoDadosList(vars.linhaTipoLicenca,
                                                                somenteDespesas)[tabIndexEstudoRevisaoDados]
                                                            }
                                                        />
                                                )}
                                                {descricaoMenu(tabEstudoFormRevisaoDadosListAux[tabIndexEstudoRevisaoDados]) ===
                                                    LABEL.recursosFinanceiros && (
                                                        <FormFormRecursosFinanceiros
                                                            values={values}
                                                            handleChange={handleChange}
                                                            setFieldValue={setFieldValue}
                                                            linhaTipoLicenca={vars.linhaTipoLicenca}
                                                            //jsonConfiguracao={vars.jsonConfiguracao}
                                                            title={tabEstudoFormRevisaoDadosList(vars.linhaTipoLicenca,
                                                                somenteDespesas)[tabIndexEstudoRevisaoDados]
                                                            }
                                                        />
                                                )}
                                                {descricaoMenu(tabEstudoFormRevisaoDadosListAux[tabIndexEstudoRevisaoDados]) ===
                                                    LABEL.seguroVida + ' - ' + LABEL.cotacao && (
                                                        <AcompanhamentoFormSeguroVida
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            handleChange={handleChange}
                                                            handleSubmit={handleSubmit}
                                                            setFieldValue={setFieldValue}
                                                            vars={vars}
                                                            popupCotacao={true}
                                                            popupApolice={false}
                                                        />
                                                )}
                                                {descricaoMenu(tabEstudoFormRevisaoDadosListAux[tabIndexEstudoRevisaoDados]) ===
                                                    LABEL.seguroVida + ' - ' + LABEL.apolice && (
                                                        <AcompanhamentoFormSeguroVida
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            handleChange={handleChange}
                                                            handleSubmit={handleSubmit}
                                                            setFieldValue={setFieldValue}
                                                            vars={vars}
                                                            popupCotacao={false}
                                                            popupApolice={true}
                                                        />
                                                )}
                                            </GridItem12>
                                        </GridContainer>
                                    </CardGridDivBodyEntradaDados>
                                </CardGridEntradaDados>
                            )}
                            
                            {descricaoMenu(tabEstudoFormRevisaoDadosListAux[tabIndexEstudoRevisaoDados]) ===
                                LABEL.planejamentoEspecializacaoPeriodoSabatico && (
                                    <EstudoFormPlanejamentoEspecializacaoPeriodoSabatico
                                        values={values}
                                        handleChange={handleChange}
                                        handleSubmitAutomatico={handleSubmitAutomatico}
                                        jsonConfiguracao={vars.jsonConfiguracao}
                                        jsonUsuario={vars.jsonUsuario}
                                        jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                    />
                            )}
                        </GridItemRevisaoDados12PlanejarEspecializacaoPeriodoSabatico6>
                    </GridContainer>
                </ValidatorFormPadrao>
            </DivForm>
        </div>
    )
}
    
export default EstudoFormRevisaoDados